/* 🤖 this file was generated by svg-to-ts */
export const matIconGif: {
  name: 'gif';
  data: string;
} = {
  name: 'gif',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M11.5 9H13v6h-1.5V9zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1h3z"/></svg>`
};
